<ng-template #imageContainer>
    @if (!config.showLoader) {
        <div
            [innerHTML]="previewImage | safe: 'html'"
            (click)="maximize()"
            class="process-widget-image"
        ></div>
    }
</ng-template>

<div class="widget-container">
    <ng-container [ngTemplateOutlet]="imageContainer"></ng-container>
</div>
